import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossAlt = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 6,
	viewBox: "0 0 6 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.44427 2.85863C1.52238 2.93674 1.52238 3.06337 1.44427 3.14147L0.323039 4.26271C0.0106193 4.57513 0.0106192 5.08166 0.323039 5.39408L0.605881 5.67692C0.918301 5.98934 1.42483 5.98934 1.73725 5.67692L2.85849 4.55569C2.93659 4.47758 3.06322 4.47758 3.14133 4.55569L4.26271 5.67706C4.57513 5.98948 5.08166 5.98948 5.39408 5.67706L5.67692 5.39422C5.98934 5.0818 5.98934 4.57527 5.67692 4.26285L4.55554 3.14147C4.47744 3.06337 4.47744 2.93673 4.55554 2.85863L5.67695 1.73722C5.98937 1.4248 5.98937 0.918272 5.67695 0.605852L5.39411 0.32301C5.08169 0.0105903 4.57515 0.0105906 4.26274 0.32301L3.14133 1.44442C3.06322 1.52252 2.93659 1.52252 2.85849 1.44442L1.73722 0.323155C1.4248 0.0107352 0.918272 0.0107352 0.605852 0.323155L0.32301 0.605997C0.0105902 0.918417 0.0105907 1.42495 0.32301 1.73737L1.44427 2.85863Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCrossAlt);
export { ForwardRef as ReactComponent };
